module.exports = __webpack_public_path__ + "static/media/gr.471d733a.svg";